<template>
  <div class="login-wrap main">
    <div class="login-html">
      <input id="tab-1" type="radio" name="tab" class="sign-in" checked><label for="tab-1" class="tab">登 录</label>
      <input id="tab-2" type="radio" name="tab" class="sign-up"><label for="tab-2" class="tab">注 册</label>
      <div class="login-form">
        <div class="sign-in-htm">
          <div class="group">
            <label class="label">手机号</label>
            <input class="user input" type="text" v-model="loginForm.phone">
          </div>
          <div class="group">
            <label class="label">密码</label>
            <input class="pass input" type="password" v-model="loginForm.password">
          </div>
          <div class="group">
            <el-checkbox v-model="adminState">业务员登录</el-checkbox>
          </div>
          <div class="group">
            <input type="submit" class="button" value="登 录" @click="loginSubmit">
          </div>
          <div class="hr"></div>
          <div class="foot-lnk">
            <a href="#" @click="forgot">忘记密码?</a>
          </div>
        </div>
        <div class="sign-up-htm">
          <div class="group">
            <label for="user" class="label">团队名称</label>
            <input id="user" type="text" class="input" v-model="registerForm.name">
          </div>
          <div class="group">
            <label for="user" class="label">手机号</label>
            <input type="text" class="input" v-model="registerForm.phone">
          </div>
          <div class="group">
            <label class="label">密码</label>
            <input type="password" class="input pass" v-model="registerForm.password">
          </div>
          <div class="group">
            <label class="label">再次确定密码</label>
            <input type="password" class="input pass" v-model="registerForm.confirm_password">
          </div>
          <div class="group">
            <label class="label">验证码</label>
            <div style="display: flex;flex-direction: row;">
              <input type="text" class="input pass" v-model="registerForm.code">
              <el-button style="margin-left: 50px;" type="info" icon="el-icon-message" circle
                         @click="sendSms"></el-button>
            </div>
          </div>
          <div class="group">
            <input type="submit" class="button" value="注 册" @click="register">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Login, Register, SendSms,TeamAdminLogin} from '../api/login'
import store from 'store'

export default {
  name: 'Login',
  data () {
    return {
      registerForm: {},
      loginForm: {},
      adminState:false,
    }
  },
  mounted () {

  },
  methods: {
    sendSms () {
      var params = {
        phone: this.registerForm.phone
      }
      console.log(params)
      SendSms(params).then(res => {
        if (res.code === 200) {
          this.$notify({
            message: '验证码发送成功',
            type: 'success'
          })
        } else {
          this.$notify({
            title:'错误',
            type:'error',
            message:res.message
          })
        }
      })
    },
    forgot(){
      window.open("/#/forgot")
    },
    loginSubmit () {
      if (this.adminState) {
        this.teamAdminLogin()
      }else{
        this.login()
      }
    },
    teamAdminLogin(){
      let that = this
      TeamAdminLogin(this.loginForm).then(res=>{
        if (res.code === 200) {
          store.set('token', res.data.token)
          store.set('team', res.data.team)
          that.$notify({
            message: '登录成功',
            type: 'success'
          })
          setTimeout(function () {
            that.$router.push({name: 'index'})
          }, 1500)
        } else {
          this.$notify({
            title:'错误',
            type:'error',
            message:res.message
          })
        }
      })
    },
    login(){
      let that = this
      Login(this.loginForm).then(res => {
        if (res.code === 200) {
          store.set('token', res.data.token)
          store.set('team', res.data.team)
          that.$notify({
            message: '登录成功',
            type: 'success'
          })
          setTimeout(function () {
            that.$router.push({name: 'index'})
          }, 1500)
        } else {
          this.$notify({
            title:'错误',
            type:'error',
            message:res.message
          })
        }
      })
    },
    register () {
      console.log(this.registerForm)
      var that = this
      if (this.registerForm.password !== this.registerForm.confirm_password) {
        that.$notify({
          title:'警告',
          message: '两次密码不一致',
          type: 'warning'
        })
        return
      }
      Register(this.registerForm).then(res => {
        console.log(res)
        if (res.code === 200) {
          store.set('token', res.data.token)
          store.set('team', res.data.team)
          that.$notify({
            message: '注册并登录成功',
            type: 'success'
          })
          setTimeout(function () {
            that.$router.push({name: 'index'})
          }, 1500)
        } else {
          that.$notify({
            type:'error',
            title:'错误',
            message:res.message
          })
        }
      })
    }
  }
}
</script>

<style scoped>
/**/
.main {
  margin: 0;
  color: #6a6f8c;
  background: #c8c8c8;
  font: 600 16px/18px 'Open Sans', sans-serif;
}

*, :after, :before {
  box-sizing: border-box
}

.clearfix:after, .clearfix:before {
  content: '';
  display: table
}

.clearfix:after {
  clear: both;
  display: block
}

a {
  color: inherit;
  text-decoration: none
}

.login-wrap {
  width: 100%;
  max-width: 525px;
  min-height: 640px;
  position: relative;
  background: url(https://raw.githubusercontent.com/khadkamhn/day-01-login-form/master/img/bg.jpg) no-repeat center;
  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, .24), 0 17px 50px 0 rgba(0, 0, 0, .19);
  margin: 50px auto auto;
}

.login-html {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 90px 70px 50px 70px;
  background: rgba(40, 57, 101, .9);
}

.login-html .sign-in-htm,
.login-html .sign-up-htm {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  transform: rotateY(180deg);
  backface-visibility: hidden;
  transition: all .4s linear;
}

.login-html .sign-in,
.login-html .sign-up,
.login-form .group .check {
  display: none;
}

.login-html .tab,
.login-form .group .label,
.login-form .group .button {
  text-transform: uppercase;
}

.login-html .tab {
  font-size: 22px;
  margin-right: 15px;
  padding-bottom: 5px;
  margin: 0 15px 10px 0;
  display: inline-block;
  border-bottom: 2px solid transparent;
}

.login-html .sign-in:checked + .tab,
.login-html .sign-up:checked + .tab {
  color: #fff;
  border-color: #1161ee;
}

.login-form {
  min-height: 345px;
  position: relative;
  perspective: 1000px;
  transform-style: preserve-3d;
}

.login-form .group {
  margin-bottom: 15px;
}

.login-form .group .label,
.login-form .group .input,
.login-form .group .button {
  width: 100%;
  color: #fff;
  display: block;
}

.login-form .group .input,
.login-form .group .button {
  border: none;
  padding: 15px 20px;
  border-radius: 25px;
  background: rgba(255, 255, 255, .1);
}

.login-form .group input[data-type="password"] {
  text-security: circle;
  -webkit-text-security: circle;
}

.login-form .group .label {
  color: #aaa;
  font-size: 12px;
  text-align: left;
}

.login-form .group .button {
  background: #1161ee;
}

.login-form .group label .icon {
  width: 15px;
  height: 15px;
  border-radius: 2px;
  position: relative;
  display: inline-block;
  background: rgba(255, 255, 255, .1);
}

.login-form .group label .icon:before,
.login-form .group label .icon:after {
  content: '';
  width: 10px;
  height: 2px;
  background: #fff;
  position: absolute;
  transition: all .2s ease-in-out 0s;
}

.login-form .group label .icon:before {
  left: 3px;
  width: 5px;
  bottom: 6px;
  transform: scale(0) rotate(0);
}

.login-form .group label .icon:after {
  top: 6px;
  right: 0;
  transform: scale(0) rotate(0);
}

.login-form .group .check:checked + label {
  color: #fff;
}

.login-form .group .check:checked + label .icon {
  background: #1161ee;
}

.login-form .group .check:checked + label .icon:before {
  transform: scale(1) rotate(45deg);
}

.login-form .group .check:checked + label .icon:after {
  transform: scale(1) rotate(-45deg);
}

.login-html .sign-in:checked + .tab + .sign-up + .tab + .login-form .sign-in-htm {
  transform: rotate(0);
}

.login-html .sign-up:checked + .tab + .login-form .sign-up-htm {
  transform: rotate(0);
}

.hr {
  height: 2px;
  margin: 60px 0 50px 0;
  background: rgba(255, 255, 255, .2);
}

.foot-lnk {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue